export const SnackbarType = {
  SUCCESS: "success",
  INFO: "info",
  WARNING: "warning",
  ERROR: "error",
  LOADING: "loading",
};